__turbopack_context__.v({
  "headerText": "Wz8bMW_headerText",
  "icon": "Wz8bMW_icon",
  "row": "Wz8bMW_row",
  "text": "Wz8bMW_text",
});
